import { Gesture, gestureLayers } from "./BaseGesture"

class SelectionKeyboardShortcut extends Gesture {
  override layer = gestureLayers.selectionKeyboardShortcut

  override async onKeyDown(keyboard: KeyboardEvent) {
    const { navigateToFile } = useNavigation()
    const { isSelectionEmpty, clearSelected, selectedFiles, isSelectedIn, selectItemUpInSidebarView, selectItemDownInSidebarView } = useSelection()
    const { removeFilesFromSidebar } = useSidebar()
    const { isEditingTextInput } = useGestures()
    const { state: myself } = useSelf()
    const { peekSelectedFiles, closePeek, isPeeking } = usePeek()
    const { state: mainViewState } = useMainView()
    const { updateFileContentBoundsSync } = useCollectionView()
    const { archiveFile } = useFileSystem()
    const {
      selectItemRightInFolderView,
      selectItemLeftInFolderView,
      selectItemUpInFolderView,
      selectItemDownInFolderView,
    } = useSelection()

    if (isSelectionEmpty() || isEditingTextInput())
      return

    const files = selectedFiles.value

    // TODO: check for permissions before deleting/moving
    if (["Backspace", "Delete"].includes(keyboard.key)) {
      if (!myself.value.archive)
        return this.warn("Cannot delete when logged out")

      this.debug("Moving selected files to archive and removing from sidebar")
      removeFilesFromSidebar(files)

      for (const file of Object.values(files))
        archiveFile(file)

      clearSelected()
      keyboard.preventDefault()
      return this.capture()
    }

    if ([" ", "Spacebar"].includes(keyboard.key)) {
      if (isPeeking.value) {
        this.debug("Closing file peek")
        closePeek()
        keyboard.preventDefault()
        return this.capture()
      }
      this.debug("Spacebar pressed. Opening file peek")
      peekSelectedFiles()
      keyboard.preventDefault()
      return this.capture()
    }

    if (["Enter"].includes(keyboard.key)) {
      if (len(files) !== 1) {
        this.warn("Cannot open two files at once, skipping")
        keyboard.preventDefault()
        return this.capture()
      }
      const file = first(files)!
      closePeek()
      if (this.commandKeyModifier(keyboard))
        file.openInNewTab()
      else
        navigateToFile(file)
      clearSelected()
      keyboard.preventDefault()
      return this.capture()
    }

    // if (["Escape"].includes(keyboard.key)) {
    //   if (isPeeking.value) {
    //     this.debug("Escape pressed. Closing file peek")
    //     closePeek()
    //     keyboard.preventDefault()
    //     return this.capture()
    //   }
    //   else {
    //     this.debug("Escape pressed. Clearing selected files")
    //     clearSelected()
    //     keyboard.preventDefault()
    //     return this.capture()
    //   }
    // }

    if (["ArrowLeft"].includes(keyboard.key)) {
      if (len(files) !== 1) {
        this.warn("Cannot keyboard navigate with multiple items pressed")
        keyboard.preventDefault()
        return this.capture()
      }
      else if (isSelectedIn(first(files)!.id, "sidebar")) {
        this.warn("Ignoring right arrow key as we made a sidebar selection")
        keyboard.preventDefault()
        return this.capture()
      }
      else if (mainViewState.value.state === "collection") {
        this.debug("Arrow left pressed, selecting item to left")
        updateFileContentBoundsSync()
        selectItemLeftInFolderView()
        keyboard.preventDefault()
        return this.capture()
      }
      // TODO: add kb nav for search results
    }

    if (["ArrowRight"].includes(keyboard.key)) {
      if (len(files) !== 1) {
        this.warn("Cannot keyboard navigate with multiple items pressed")
        keyboard.preventDefault()
        return this.capture()
      }
      else if (isSelectedIn(first(files)!.id, "sidebar")) {
        this.warn("Ignoring right arrow key as we made a sidebar selection")
        keyboard.preventDefault()
        return this.capture()
      }
      else if (mainViewState.value.state === "collection") {
        this.debug("Arrow right pressed, selecting item to right")
        updateFileContentBoundsSync()
        selectItemRightInFolderView()
        keyboard.preventDefault()
        return this.capture()
      }
    }

    if (["ArrowUp"].includes(keyboard.key)) {
      if (len(files) !== 1) {
        this.warn("Cannot keyboard navigate with multiple items pressed")
        keyboard.preventDefault()
        return this.capture()
      }
      keyboard.preventDefault()
      if (isSelectedIn(first(files)!.id, "sidebar")) {
        this.debug("Arrow up pressed in sidebar, selecting item above")
        selectItemUpInSidebarView()
        keyboard.preventDefault()
        return this.capture()
      }
      else if (mainViewState.value.state === "collection") {
        this.debug("Arrow up pressed, selecting item above")
        updateFileContentBoundsSync()
        selectItemUpInFolderView()
        keyboard.preventDefault()
        return this.capture()
      }
      // TODO: add kb nav for search results
    }

    if (["ArrowDown"].includes(keyboard.key)) {
      if (len(files) !== 1) {
        this.warn("Cannot keyboard navigate with multiple items pressed")
        keyboard.preventDefault()
        return this.capture()
      }
      keyboard.preventDefault()
      if (isSelectedIn(first(files)!.id, "sidebar")) {
        this.debug("Arrow up pressed in sidebar, selecting item above")
        selectItemDownInSidebarView()
        keyboard.preventDefault()
        return this.capture()
      }
      else if (mainViewState.value.state === "collection") {
        this.debug("Arrow down pressed, selecting item below")
        updateFileContentBoundsSync()
        selectItemDownInFolderView()
        keyboard.preventDefault()
        return this.capture()
      }
    }
  }

  /**
   * TODO: address different OS'es, and test on Windows
   * @param keyboard event
   * @returns whether the OS-specific modifier key is pressed
   */
  commandKeyModifier(keyboard: KeyboardEvent) {
    return keyboard.metaKey || keyboard.ctrlKey
  }

  shiftKeyModifier(keyboard: KeyboardEvent) {
    return keyboard.shiftKey
  }
}

const selectionKeyboardShortcut = new SelectionKeyboardShortcut()
export default function () {
  return selectionKeyboardShortcut
}
